import { Link } from '@tanstack/react-router'
import { HomeIcon } from 'lucide-react'

import { Breadcrumb, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '@/components/breadcrumb'

import { useBreadcrumbs } from '@/state/breadcrumbs'

const Breadcrumbs = () => {
    const breadcrumbs = useBreadcrumbs()

    return (
        <Breadcrumb className="mb-4">
            <BreadcrumbList>
                <BreadcrumbLink asChild>
                    <Link to="/">
                        <HomeIcon className="h-4 w-4" />
                    </Link>
                </BreadcrumbLink>
                <BreadcrumbSeparator />
                {breadcrumbs.map((breadcrumb, index) => {
                    if (breadcrumb === 'seperator') {
                        return <BreadcrumbSeparator key={index} />
                    }

                    return (
                        <BreadcrumbLink key={index} asChild>
                            <Link to={breadcrumb.to} params={breadcrumb.params}>
                                {breadcrumb.text}
                            </Link>
                        </BreadcrumbLink>
                    )
                })}
            </BreadcrumbList>
        </Breadcrumb>
    )
}

export default Breadcrumbs
